
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getGetTasksByProjectIdsDtoFormGroup() {
return new FormGroup({
    projectIds: new FormControl<Array<number> | undefined>([], [Validators.required]),
    standardTaskIds: new FormControl<Array<number> | undefined>([], [Validators.required]),
})
;
}
      